export class MonthModel {
    number: string;
    name: string;
    selected: boolean;

    constructor() {
        this.selected = false;
    }
}
